import { GridView, MenuOutlined } from "@mui/icons-material";
import {
  Paper,
  Portal,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";

import DatasetCardSearch from "./components/DatasetCardSearch";
import DatasetTableSearch from "./components/DatasetTableSearch";
import { useState } from "react";

const DatasetPageView = () => {
  const localStorageLayoutValue = localStorage.getItem("datasetViewMode");
  const [viewMode, setViewMode] = useState(localStorageLayoutValue || "card");

  const handleViewChange = (
    _event: React.MouseEvent<HTMLElement>,
    value: any,
  ) => {
    if (value !== null) {
      setViewMode(value);
      localStorage.setItem("datasetViewMode", value);
    }
  };

  const renderViewComponent = () => {
    switch (viewMode) {
      case "card":
        return <DatasetCardSearch atomResults={false} />;
      case "list":
        return <DatasetTableSearch atomResults={false} />;
      default:
        return <DatasetCardSearch />;
    }
  };

  return (
    <div>
      <Portal container={() => document.getElementById("toggle-dataset-view")!}>
        <Paper elevation={0}>
          <Stack flexDirection="row" justifyContent="flex-end">
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={handleViewChange}
              aria-label="View mode"
              size="small"
              color="primary"
            >
              <Tooltip title="List layout" placement="top">
                <ToggleButton
                  value="list"
                  aria-label="list view"
                  data-testid="ds-btn-view-list"
                  data-attr="datasets:toggle:switch-to-list-view"
                >
                  <MenuOutlined />
                </ToggleButton>
              </Tooltip>
              <Tooltip title="Grid layout" placement="top">
                <ToggleButton
                  value="card"
                  aria-label="Grid view"
                  data-testid="ds-btn-view-grid"
                  data-attr="datasets:toggle:switch-to-grid-view"
                >
                  <GridView />
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          </Stack>
        </Paper>
      </Portal>
      {renderViewComponent()}
    </div>
  );
};

export default DatasetPageView;
